import React from "react";
import styled, { css } from "styled-components";
import { CalendlyBtn } from "../../Button";
import ModuleNavButton from "../../Button/ModuleNavButton";

const LinkWrapper = styled.a`
  display: block;
  cursor: pointer;
  text-decoration: none;
  margin-right: 20px;
  &:last-of-type, &:last-child {
    margin-right: 0;
  }
  ${props =>
    props.hidden &&
    css`
    display: none;
  `}
`;

const StyledCalendlyBtn = styled(CalendlyBtn)`
  ${props =>
    props.hidden &&
    css`
    display: none;
  `}
`;

const LinkButton = ({ buttonType, onClick, href, label, calendly, hidden }) => {
  if (calendly) return (
    <StyledCalendlyBtn buttonType="ModuleNavButton" variant={buttonType} hidden={hidden}>
      {label}
    </StyledCalendlyBtn>
    );
  return (
    <LinkWrapper onClick={onClick} href={href}>
      <ModuleNavButton type={buttonType}>{label}</ModuleNavButton>
    </LinkWrapper>

  );
};

export default LinkButton;
